/**
 * The markdown filename suffix. Used as a visual hint when a content
 * surface is in markdown mode, and as the gesture trigger for switching
 * to markdown mode (e.g. typing `.md` at the end of a title).
 */
export const MARKDOWN_SUFFIX = '.md';

/**
 * Whether `s` ends with the markdown suffix, ignoring trailing whitespace
 * so `'Hello.md '` and `'Hello.md\n'` are treated as suffixed.
 */
export const endsWithMarkdownSuffix = (s: string): boolean => s.trimEnd().endsWith(MARKDOWN_SUFFIX);

/**
 * Returns `s` with a trailing markdown suffix (and any trailing whitespace
 * around it) removed. Returns `s` unchanged if no suffix is present.
 */
export const stripMarkdownSuffix = (s: string): string => {
	const trimmed = s.trimEnd();
	return trimmed.endsWith(MARKDOWN_SUFFIX) ? trimmed.slice(0, -MARKDOWN_SUFFIX.length) : s;
};
